var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2473 2.2776C8.4666 2.37527 8.60788 2.59285 8.60788 2.83291V13.1671C8.60788 13.4072 8.4666 13.6248 8.2473 13.7225C8.028 13.8201 7.77176 13.7796 7.59332 13.619L4.72723 11.0395H2.52892C2.19318 11.0395 1.92102 10.7673 1.92102 10.4316V5.56845C1.92102 5.23271 2.19318 4.96055 2.52892 4.96055H4.72723L7.59332 2.38107C7.77176 2.22047 8.028 2.17993 8.2473 2.2776ZM7.39208 4.19786L5.36716 6.02029C5.25554 6.12075 5.11068 6.17634 4.9605 6.17634H3.13681V9.82372H4.9605C5.11068 9.82372 5.25554 9.87931 5.36716 9.97977L7.39208 11.8022V4.19786ZM9.71942 9.71946C10.669 8.76986 10.669 7.23027 9.71942 6.28068L10.5791 5.42098C12.0035 6.84537 12.0035 9.15476 10.5791 10.5792L9.71942 9.71946ZM11.4387 4.56124C13.3379 6.46043 13.3379 9.53962 11.4387 11.4388L12.2984 12.2985C14.6724 9.92451 14.6724 6.07553 12.2984 3.70155L11.4387 4.56124Z",
    fill: "#1B439A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.71e138bf23a09bec8e6791763fc9df9c.svg";
export { ForwardRef as ReactComponent };